export default __webpack_public_path__ + "static/media/cvod-RP13.62287219.svg";